// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { FilterOption } from '@/components/filter-toggle-group';
import {
  ListOutlined,
  ViewTimelineOutlined,
} from '@/constants/hardfin-standard-icons';
import { ProjectViewMode } from '@/constants/project-view-mode';

export const PROJECT_VIEW_MODE_OPTIONS: FilterOption<ProjectViewMode>[] = [
  {
    value: 'timeline',
    label: 'Timeline',
    icon: <ViewTimelineOutlined fontSize="small" />,
  },
  { value: 'table', label: 'Table', icon: <ListOutlined fontSize="small" /> },
];
